import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledButton } from "../../Styled/Button"
import { StyledColumn } from "../../Styled/Column"
import { StyledImage } from "../../Styled/Image"
import { StyledRow } from "../../Styled/Row"
import { H4, RichText, H6 } from "../../Styled/Text"

export const Section = tw.section`relative bg-white md:py-8`
export const Background = tw(StyledRow)`absolute inset-0`
export const Content = tw.div`w-full md:w-4/5`
export const Icon = tw.div`absolute w-full h-full inset-0 px-10 -mt-12 md:-mt-8`
export const IconInner = tw.div`flex items-center justify-center w-full h-full`
export const Svg = tw.svg`w-full max-w-full max-h-full opacity-10`
export const Column = styled(StyledColumn)`
  ${tw`relative`}
  ${({ blue }) => blue && tw`md:bg-teal-sky`}
  ${({ gutter }) => gutter && tw`flex-col pt-15 last:pb-15 md:py-20`}
`
export const Images = tw.div`relative flex items-center justify-center w-full h-full`
export const Image = tw(StyledImage)`w-full max-w-full`
export const Title = tw(H4)`mb-10 last:mb-0`
export const Subtitle = tw(RichText)`font-light max-w-full md:w-5/6`
export const Pretitle = tw(H6)`font-normal tracking-loose text-sm md:text-sm mb-8`
export const Buttons = tw.div`md:flex w-full md:w-1/2 flex-col items-center justify-center mt-12 md:mt-4`
export const Button = tw(StyledButton)`w-full mb-6 last:mb-0`
